export type DialogSizes = 'sm' | 'md' | 'lg';
export type OverflowTypes = 'visible' | 'hidden' | 'scroll' | 'auto' | 'initial' | 'inherit';
export type ScrollTypes = 'body' | 'paper';

export const dialogSizes = {
  sm: 440,
  md: 720,
  lg: 900,
};
